import { RowVehicleGroupCompanyDto } from "@/dtos";
import { VehicleGroupCompany } from "@/entities";

export const formatRowVehicleGroupCompany = (vehicleGroupCompanies: VehicleGroupCompany[]): RowVehicleGroupCompanyDto[] => {
    return vehicleGroupCompanies.map(x => {
        const row: RowVehicleGroupCompanyDto = {
            ...x,
            company_label: x.company.name
        }
        return row;
    });
}